import React, { useState } from "react";
import { Modal } from "antd";
import HeaderComponent from "components/card/HeaderComponent";

export default function HeaderModal( props ) {
 const { open, onClose, icon, width="600px", border, title, titleClass, childrenClass, description, descriptionClass, cardBorder,children, bgcolor, colorTheme, labelIcon, rightNav, footer, closable=true, backgroundStyle, useCustomClass="true" , group } = props;

 const modalClassName = [
    useCustomClass ? "custom-ant-modal-content" : "",
    typeof width === "string" ? width : "",
  ]
  .filter(Boolean)
  .join(" ");

  return (
    <>
      <Modal
        open={open}
        onCancel={onClose} 
        footer={null}
        width={{
          xs: '98%',
          sm: '98%',
          md: '90%',
          lg: '70%',
        }}
        className={modalClassName}
        closable={closable}
        style={{ maxWidth: width, margin: "0 auto" }}
      >
        <div className={group}>
            <HeaderComponent
              icon={icon}
              title={title}
              cardBorder={cardBorder}
              border={border}
              titleClass={titleClass}
              description={description}
              descriptionClass={descriptionClass}
              bgcolor={bgcolor}
              colorTheme={colorTheme}
              labelIcon={labelIcon}
              backgroundStyle={backgroundStyle}
              rightNav={rightNav}
              childrenClass={childrenClass}
              footer={footer}
            >
              {children}
            </HeaderComponent>
        </div>
         
      </Modal>
    </>
  );
}
